import { render } from "./ListByGenreView.vue?vue&type=template&id=30a57720"
import script from "./ListByGenreView.vue?vue&type=script&lang=js"
export * from "./ListByGenreView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__